import React, { Component } from 'react'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'
export class Credential extends Component {
    componentDidMount() {
        this.props.selectMode('integration_guide');
    }
    render() {
        return (
        <div className="stepPageContainer">   
             <h3 className="stepPageTitle">Credential on File and Recurring Billing</h3>
                            <p className="note">
                                <strong>NOTE: </strong> 
                                The value of the payment indicator field must be <b>R</b> when sending Recurring Billing
                                transactions.    
                            </p>
            <p>For Recurring Billing transactions which are set to start <b>immediately</b>:</p>
            <ol>
                <li>Send a Purchase transaction request with both the Recurring Billing and Credential on File info
                    objects (with Recurring Billing object field <b>start now</b> = true)
                </li>
            </ol>
            <p>For Recurring Billing transactions which are set to start on a <b>future</b> date:</p>
            <ol>
                <li>Send Card Verification transaction request including the Credential on File info object to get the
                    Issuer ID
                </li>
                <li>Send Purchase transaction request with the Recur and Credential on File info objects included
                </li>
            </ol>
            <p>For updating a Recurring Billing series where you are updating the card number (does not apply if you are
                only modifying the schedule or amount in a recurring series):</p>
            <ol>
                <li>Send Card Verification request including the Credential on File info object to get the Issuer ID
                </li>
                <li>Send a Recurring Billing Update transaction
                </li>
            </ol>

            <p>For more information about the Recurring Billing object, see Definition of Request Fields – Recurring.</p>
           
        </div>
        )
    }
}


const mapStateToProps = state => {
    const {mode} = state.common.sideNav;
    return { mode};
  }
  
export default connect(mapStateToProps, { selectMode})(Credential)
  
  
  